import React from 'react';
import SubjectSection from './SubjectSection';

export default function YearSection({ year }) {
  return (
    <section style={{ marginTop: 'var(--space-6)' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 'var(--space-2)',
          marginBottom: 'var(--space-4)',
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 'var(--text-section-size)',
            fontWeight: 800,
            color: 'var(--text-primary)',
            letterSpacing: '-0.01em',
          }}
        >
          {year.label}
        </h2>
        {year.isCurrent && (
          <span
            style={{
              fontSize: 'var(--text-label-size)',
              fontWeight: 700,
              color: 'var(--accent-text)',
              background: 'var(--accent-light)',
              padding: 'var(--space-1) var(--space-2)',
              borderRadius: 'var(--radius-full)',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            Current
          </span>
        )}
      </div>
      <div style={{ display: 'grid', gap: 'var(--space-5)' }}>
        {(year.subjects || []).map((s) => (
          <SubjectSection key={`${year.year}-${s.subject}`} subject={s} />
        ))}
      </div>
    </section>
  );
}
